import { render, staticRenderFns } from "./long-title.vue?vue&type=template&id=8e07d48c&scoped=true"
import script from "./long-title.vue?vue&type=script&lang=js"
export * from "./long-title.vue?vue&type=script&lang=js"
import style0 from "./long-title.vue?vue&type=style&index=0&id=8e07d48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e07d48c",
  null
  
)

export default component.exports